/**
 * SCD Lot 0 — Engagements spot (SCD) vidés.
 * Exports conservés pour compatibilité avec tenderHelpers / spotEngagementSlice.
 */
export const SPOT_TENDERS = [];

/**
 * Helper: is a tender a "spot exclusivity" engagement ?
 */
export function isSpotTender(tender) {
  return !!(tender && tender.spot === true);
}
